import { jsx as _jsx } from "react/jsx-runtime";
export const NoMatch = () => (_jsx("div", { children: "Page not found." }));
